// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vQRR","question":"styles_question__3HTp8","description":"styles_description__24ASz"};